export default __webpack_public_path__ + "static/media/edit.d77817f4.svg";